export default __webpack_public_path__ + "static/media/magicLogo.49544a1f.png";